type Props = {
  circleStroke?: string;
  className?: string;
  fill?: string;
  height?: number;
  stroke?: string;
  width?: number;
};

const InformationIcon = ({
  height = 16,
  width = 16,
  stroke = 'white',
  fill = 'black',
  circleStroke = 'black',
  className = ''
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="8" cy="8" r="6.5" stroke={circleStroke} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.39202 6.00026C7.56008 6.16585 7.76175 6.24865 7.99703 6.24865C8.24575 6.24865 8.44741 6.16585 8.60203 6.00026C8.76336 5.82804 8.84403 5.6194 8.84403 5.37432C8.84403 5.12262 8.76336 4.91398 8.60203 4.74839C8.44741 4.5828 8.24575 4.5 7.99703 4.5C7.76175 4.5 7.56008 4.5828 7.39202 4.74839C7.23069 4.91398 7.15002 5.12262 7.15002 5.37432C7.15002 5.6194 7.23069 5.82804 7.39202 6.00026ZM8.67458 7.09559H7.31938V11.5H8.67458V7.09559Z"
        fill={stroke}
      />
    </svg>
  );
};

export default InformationIcon;
